import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { REFRESH_INTERVAL } from 'configs/constants';
import { sdClient } from 'contexts/SDKClientContext';

async function fetchLocationHardwareStatus(locationId: string) {
    try {
        return await sdClient.getLocationHardwareSummaryStatus({
            locationId,
        });
    } catch (error) {
        throw new Error(
            `Failed to fetch hardware status for location ${locationId}: ${
                error instanceof Error ? error.message : 'Unknown error'
            }`
        );
    }
}

export function useLocationHardwareStatus(locationId: string) {
    return useQuery({
        queryKey: ['locationHardwareStatus', locationId],
        queryFn: () => fetchLocationHardwareStatus(locationId),
        refetchInterval: REFRESH_INTERVAL,
        placeholderData: keepPreviousData,
        staleTime: REFRESH_INTERVAL,
    });
}
